import React from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Button';
import styles from './styles.scss';

export default class JobListItem extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    introtext: PropTypes.string.isRequired,
    date: PropTypes.string,
    location: PropTypes.string,
    category: PropTypes.string,
    ctaHref: PropTypes.string.isRequired,
  };

  render() {
    const { title, introtext, date, location, category, ctaHref } = this.props;

    return (
      <div className={styles.joblistitem}>
        <div className={styles.head}>
          <h4>{title}</h4>
          <h3>{title}</h3>
          <ul className={styles.shortfacts}>
            {date && <li>{date}</li>}
            {location && <li>{location}</li>}
            {category && <li>{category}</li>}
          </ul>
        </div>
        <div className={styles.content}>
          <p className={styles.introtext}>{introtext}</p>
          <span className={styles.secondary}>
            <Button label="Details" type="secondary" href={ctaHref} small />
          </span>
          <span className={styles.primary}>
            <Button label="Details" type="primary" href={ctaHref} small />
          </span>
        </div>
      </div>
    );
  }
}
